module.exports = __webpack_public_path__ + "static/media/reading.f96453fc.png";